// extracted by mini-css-extract-plugin
module.exports = {"buttonClass":"CompareButton_buttonClass__R7io1","lightButtonClass":"CompareButton_lightButtonClass__FnEbx"};